import {
   AlertSound,
   AlertColor,
   AlertThreshold,
   AlertTextMessage,
   AlertEmailMessage,
   AlertChannelForm,
   AlertOxygenLevel,
   AlertDelayPeriod,
   AlertSource,
} from "./alert"
import { AlertConfigurationResponse } from "@/api/AlertConfigurationsService"

export type AlertConfigurationForm = Omit<
   AlertConfigurationResponse,
   "channels"
> & {
   channels?: AlertChannelForm[]
}

export type AlertDataSharing = {
   jms: boolean
   techCare: boolean
   coreForce: boolean
   guardian: boolean
}

export enum AlertSystemConditionType {
   OUT_OF_BOUNDS = "out_of_bounds",
   NO_VITALS = "no_vitals",
   BROKEN_WEARABLE = "broken_device",
}

export enum AlertCategory {
   SYSTEM = "system",
   VITAL = "vitals",
}

export type AlertSystemCondition = {
   id: string
   mainThreshold: number | null
   secondaryThreshold: number | null
   type: AlertSystemConditionType
}

export interface AlertConfiguration {
   id: string
   priority: number
   name: string
   soundFrequency: AlertSound["frequency"]
   soundClip: AlertSound["clip"]
   dataSharing: AlertDataSharing
   colorCard: AlertColor["card"]
   colorIcon: AlertColor["icon"]
   colorTypeface: AlertColor["typeface"]
   delayPeriod?: AlertDelayPeriod["duration"]
   heartRateThreshold?: AlertThreshold
   respiratoryRateThreshold?: AlertThreshold
   oxygenLevel?: AlertOxygenLevel
   temperatureThreshold?: AlertThreshold
   thresholdSet: boolean
   thresholdSetSmall?: boolean
   sensorTypes?: AlertSource[]
   wearableType?: boolean
   sensorType?: boolean
   textMessage?: AlertTextMessage
   emailMessage?: AlertEmailMessage
   order?: number
   draggable?: boolean
   systemCondition: AlertSystemCondition | null
   category: AlertCategory
   enabled: boolean
}
